import Api from '@/services/Api'
import MetodosGlobais from '@/utils/MetodosGlobais'

const RECURSO = '/servicos156'
export default {
  topServicosOuvidoriaPorRegiao,
  servicosNaoGeorreferenciadosOuvidoria,
  solicitacoesOuvidoria,
  topServicosOuvidoriaConsolidados,
  topAssuntosDemandadosOuvidoria,
  topTemasDemandadosOuvidoria,
  topServicosOuvidoriaPorOrgao,
  solicitacoesOuvidoriaConsolidado,
}

function topServicosOuvidoriaPorRegiao ({ top, intervalo, ordenacao, filtroId }) {
  let params = { 'top': top, 'intervalo': intervalo, 'ordenacao': ordenacao, 'filtroId': filtroId }
  return Api.get(`${RECURSO}/topServicosOuvidoriaPorRegiao${MetodosGlobais.createEncodeQuery(params)}`)
}
function topServicosOuvidoriaConsolidados ({ top, intervalo, ordenacao }) {
  let params = { 'top': top, 'intervalo': intervalo, 'ordenacao': ordenacao }
  return Api.get(`${RECURSO}/topServicosOuvidoriaConsolidados${MetodosGlobais.createEncodeQuery(params)}`)
}
function topTemasDemandadosOuvidoria ({ top, intervalo, ordenacao }) {
  let params = { 'top': top, 'intervalo': intervalo, 'ordenacao': ordenacao }
  return Api.get(`${RECURSO}/topTemasDemandadosOuvidoria${MetodosGlobais.createEncodeQuery(params)}`)
}
function topAssuntosDemandadosOuvidoria ({ top, intervalo, ordenacao }) {
  let params = { 'top': top, 'intervalo': intervalo, 'ordenacao': ordenacao }
  return Api.get(`${RECURSO}/topAssuntosDemandadosOuvidoria${MetodosGlobais.createEncodeQuery(params)}`)
}
function servicosNaoGeorreferenciadosOuvidoria ({ intervalo }) {
  let params = { 'intervalo': intervalo }
  return Api.get(`${RECURSO}/servicosNaoGeorreferenciadosOuvidoria${MetodosGlobais.createEncodeQuery(params)}`)
}
function solicitacoesOuvidoria ({ intervalo }) {
  let params = { 'intervalo': intervalo }
  return Api.get(`${RECURSO}/solicitacoesOuvidoria/porOrgao${MetodosGlobais.createEncodeQuery(params)}`)
}
function topServicosOuvidoriaPorOrgao ({ top, intervalo, ordenacao, filtroId }) {
  let params = { 'top': top, 'intervalo': intervalo, 'ordenacao': ordenacao, 'filtroId': filtroId }
  return Api.get(`${RECURSO}/topServicosOuvidoriaPorOrgao${MetodosGlobais.createEncodeQuery(params)}`)
}
function solicitacoesOuvidoriaConsolidado () {
  return Api.get(`${RECURSO}/solicitacoesOuvidoria/consolidado`)
}
